import { render, staticRenderFns } from "./ChildAccount.vue?vue&type=template&id=36ac1f28&scoped=true&"
import script from "./ChildAccount.vue?vue&type=script&lang=js&"
export * from "./ChildAccount.vue?vue&type=script&lang=js&"
import style0 from "./ChildAccount.vue?vue&type=style&index=0&id=36ac1f28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac1f28",
  null
  
)

export default component.exports